// Workspace metadata KLM-8948

import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import ShowWsmetadata from './ShowWsmetadata';

class WorkspaceMetaData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalFlag: false,
            preMeta: {}
        }
    }

    componentWillMount() {
        if(this.props.workspaceMetaData.metaData) {
            this.setState({
                preMeta: this.props.workspaceMetaData.metaData
            })
        }
        else {
            this.setState({
                preMeta: {
                    "N/A": "This workspace has no metadata."
                }
            })
        }
    }

    openModal() {
        this.setState({modalFlag: true})
    }

    closeModal() {
        this.setState({modalFlag: false})
    }

    setMetaDataFlag = async (flag) => {
        await this.setState({ modalFlag: flag });
    };

    setRefPreMeta = async (data) => {
        this.setState({
            preMeta: data
        })
    }

    render() {

        return (
            <div>
                <div className="acc-header">MetaData
                    <span
                        style={{ margin: "0 20px" }}
                        className="clr-gray fs_italic"
                    >
                        <Button
                            content="Edit"
                            className="button-submit float-right"
                            type="button"
                            onClick={() => this.setMetaDataFlag(true)}
                        />
                    </span>
                </div>
                <div style={{marginTop: "20px", width: "920px", height: "520px", overflow: "scroll"}}>
                    <pre>{JSON.stringify(this.state.preMeta, null, 2)}</pre>
                </div>
                <ShowWsmetadata
                    open={this.state.modalFlag}
                    setMetaDataFlag={this.setMetaDataFlag}
                    refPreMeta={this.setRefPreMeta}
                    workspaceMetaData={this.props.workspaceMetaData} />
            </div>
        )
    }
}

export default WorkspaceMetaData